<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-plus]="true"
          style="font-size: 2rem"></i>
        DAR DE ALTA UN PROYECTO
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Guardar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4 gap-2">
      <span class="text-2xl font-bold">Datos del proyecto</span>
      <span class="text-[16px] font-normal text-neutral-dark">Escribe los datos del proyecto</span>
      <span class="text-[16px] text-neutral-dark py-3">
        Todos los campos marcados con un asterisco (*) son obligatorios.
      </span>
    </div>

    <!-- Datos identificativos -->
    <div class="flex flex-col gap-3">
      <span class="text-[18px] font-bold">Datos identificativos del proyecto</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="project-name">
            Nombre del proyecto*
          </label>
          <desy-input
            id="project-name"
            [classes]="'w-full'"
            [placeholder]="'Nombre del proyecto'"
            formControlName="projectName"></desy-input>
          <desy-error-message *ngIf="getError(form, 'projectName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="username">
            Usuario responsable y puesto*
          </label>
          <p-autoComplete
            formControlName="userNameResponsible"
            [suggestions]="usersList"
            (completeMethod)="onSearchUser($event)"
            (onSelect)="onUserSelected($event)"
            placeholder="Búsqueda por nombre, apellidos, código o puesto"
            class="pt-2 w-full flex-1 block"
            optionLabel="infoCompleted"
            optionValue="infoCompleted"
            [forceSelection]="true"
            [minLength]="3">
            <ng-template
              let-item
              pTemplate="item">
              {{ item.infoCompleted }}
            </ng-template>
          </p-autoComplete>
          <desy-error-message *ngIf="getError(form, 'userNameResponsible', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="contact-email-responsible">
            Correo electrónico de contacto del responsable*
          </label>
          <desy-input
            id="contact-email-responsible"
            [classes]="'w-full'"
            formControlName="contactEmailResponsible"></desy-input>
          <desy-error-message *ngIf="getError(form, 'contactEmailResponsible', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="department">
            Departamento responsable*
          </label>
          <desy-input
            id="department"
            [classes]="'w-full'"
            [placeholder]="'Departamento responsable'"
            formControlName="department"></desy-input>
          <desy-error-message *ngIf="getError(form, 'department', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1 w-full">
          <label
            class="text-[16px]"
            for="org-code">
            Nombre dirección general, SGT u organismo público responsable*
          </label>
          <p-autoComplete
            formControlName="selectedOrgCode"
            [suggestions]="organismsList()"
            (completeMethod)="onSearchOrganization($event)"
            (onSelect)="onOrganismSelected($event)"
            placeholder="Busqueda nombre del organismo"
            class="pt-2 w-full flex-1 block"
            [ngClass]="{ 'disabled-autocomplete': form.get('selectedOrgCode')?.disabled }"
            optionLabel="organismo"
            optionValue="codigo_organismo"
            [minLength]="3">
            <ng-template
              let-item
              pTemplate="item">
              {{ item.codigo_organismo }} - {{ item.organismo }}
            </ng-template>
            <ng-template
              let-item
              pTemplate="selectedOption">
              {{ item.codigo_organismo }} - {{ item.organismo }}
            </ng-template>
          </p-autoComplete>
        </div>

        <div class="flex flex-col flex-1">
          <span>Nombre del servicio o unidad administrativa responsable*</span>
          <desy-input
            id="service-name"
            [classes]="'w-full'"
            formControlName="serviceName"></desy-input>
          <desy-error-message *ngIf="getError(form, 'serviceName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <!-- Datos funcionales -->
    <div class="flex flex-col gap-3 py-8">
      <span class="text-xl font-bold">Datos funcionales del proyecto</span>
      <div class="flex flex-col">
        <div class="text-[16px]">Finalidad del proyecto*</div>
        <div class="text-[16px] text-neutral-dark">
          Explicación funcional del sistema de IA y problemas que resuelve
        </div>

        <desy-textarea
          formControlName="systemFinality"
          classes="w-full text-[16px]"
          class="w-full"
          [rows]="5"
          [maxlength]="500"></desy-textarea>
        <!-- Es posible que cambie a 150 en el futuro debido a como se generan los informes -->
        <desy-error-message *ngIf="getError(form, 'systemFinality', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>

        <div class="grid grid-cols-2 gap-4 mb-4">
          <div class="flex flex-col col-span-2 gap-2 justify-between mb-8">
            <div class="flex flex-col">
              <span>Procedimientos administrativos*</span>
              <span class="text-neutral-dark text-[16px]">
                En caso de no haber correspondencia, contacte con su unidad de apoyo de administración electrónica.
              </span>
            </div>
            <div class="procedure-autocomplete-field">
              <p-autoComplete
                #procedureAutocomplete
                [(ngModel)]="procedureSearch"
                [ngModelOptions]="{ standalone: true }"
                [suggestions]="proceduresList"
                (completeMethod)="onSearchProcedure($event)"
                (onSelect)="onProcedureSelected($event)"
                (onFocus)="clearProcedureSearch()"
                (keydown.enter)="onProcedureSearchEnter($event, procedureAutocomplete)"
                [forceSelection]="true"
                placeholder="Buscar procedimiento"
                optionLabel="name"
                [minLength]="3"
                [dropdown]="false"
                [inputStyle]="{ width: '100%', 'padding-right': '2.75rem' }">
                <ng-template
                  let-item
                  pTemplate="item">
                  {{ item.code }} - {{ item.name }}
                </ng-template>
                <ng-template pTemplate="loadingicon"></ng-template>
                <ng-template pTemplate="empty">
                  @if (procedureSearchLoading) {
                    <div class="procedure-loading-row">
                      <span>Cargando resultados</span>
                      <i class="pi pi-spinner pi-spin"></i>
                    </div>
                  } @else {
                    No se encontraron resultados
                  }
                </ng-template>
              </p-autoComplete>
              <button
                type="button"
                class="procedure-search-button"
                aria-label="Buscar procedimiento"
                (mousedown)="$event.preventDefault()"
                (click)="searchCurrentProcedure(procedureAutocomplete, $event)">
                <i class="pi pi-search"></i>
              </button>
            </div>
            <div class="flex gap-2 flex-wrap mt-2">
              <app-pill
                *ngFor="let proc of currentProcedures()"
                [value]="proc.code + ' - ' + proc.name"
                [classe]="'c-pill--primary'"
                [isDeletable]="true"
                (accions)="removeProcedure(proc.code)"></app-pill>
            </div>
            <div class="mt-24 py-2 absolute">
              <desy-error-message *ngIf="getError(form, 'selectedProcedure', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
          </div>
          <div class="flex flex-col col-span-1 justify-end">
            <label
              class="text-[16px]"
              for="system-or-app">
              Aplicaciones o sistemas relacionados*
            </label>
            <div class="flex flex-col">
              <div class="flex flex-row gap-2">
                <div class="w-full items-end">
                  <desy-input
                    id="system-or-app"
                    [classes]="'w-full'"
                    [placeholder]="'Escriba el nombre de la aplicación o sistema'"
                    [ngModel]="application()"
                    (ngModelChange)="application.set($event)"
                    [ngModelOptions]="{ standalone: true }"></desy-input>
                </div>
                <div class="mt-2">
                  <app-buttons
                    type="button"
                    (click)="addApplication($event)"
                    [label]="'Añadir'"
                    [classes]="'bg-primary-base text-white'"></app-buttons>
                </div>
              </div>
            </div>
            <div class="flex gap-1 flex-wrap -mt-5">
              @for (item of applications(); track item) {
                <app-pill
                  [value]="item"
                  [classe]="'c-pill--primary'"
                  [isDeletable]="true"
                  (accions)="removeApplication(item)" />
              }
            </div>
            <desy-error-message *ngIf="getError(form, 'systemOrApp', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>
        </div>
        <div class="text-[16px]">Trámite administrativo o proceso involucrado</div>
        <div class="text-[16px] text-neutral-dark">
          En caso de no afectar a ningún servicio o procedimiento administrativo incluido en SEDA, indicar los
          servicios, trámites o procesos involucrados
        </div>
        <desy-textarea
          formControlName="administrativeProcess"
          classes="w-full"
          class="w-full"
          [rows]="5"
          [maxlength]="500"></desy-textarea>
        <desy-error-message *ngIf="getError(form, 'administrativeProcess', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>
    </div>

    <!-- Datos económicos -->
    <div class="flex flex-col gap-3">
      <span class="text-xl font-bold mb-2">Datos económicos del proyecto</span>
      <div class="grid grid-cols-2 items-end gap-4">
        <div class="flex flex-col col-span-2 gap-4 items-stretch">
          <div
            class="flex flex-col gap-4"
            formArrayName="before">
            <div class="flex w-full items-center justify-between gap-4">
              <label
                class="text-[16px] font-semibold flex-1 max-w-[820px]"
                for="total-people-before-0">
                Empleados públicos de la unidad o servicio implicados en la tramitación del procedimiento o servicio
                antes del despliegue del proyecto IA*
              </label>
              <desy-button
                class="flex-shrink-0"
                [type]="'button'"
                classes="c-button c-button--primary ng-star-inserted"
                (clickEvent)="addBeforeRow()">
                Añadir registro
              </desy-button>
            </div>
            <span class="text-[16px] text-neutral-dark">
              Cada registro debe tener cumplimentados los 3 campos obligatorios.
            </span>
            <desy-table-advanced
              classes="min-w-full employee-table"
              idPrefix="table-before-employees"
              [wrapper]="{ classes: 'overflow-x-auto' }">
              <desy-table-advanced-header>
                <desy-table-advanced-header-cell>
                  <desy-content>Total de empleados públicos antes del despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Grupo de administración antes del despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Nivel de puesto antes del despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Acción</desy-content>
                </desy-table-advanced-header-cell>
              </desy-table-advanced-header>
              @for (row of beforeEmployeeRows; track $index) {
                <desy-table-advanced-row [formGroupName]="$index">
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'total-people-before-' + $index"
                      [classes]="'w-full'"
                      type="number"
                      step="0.01"
                      min="0"
                      inputmode="decimal"
                      formControlName="totalPeople"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'totalPeople') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'group-administration-before-' + $index"
                      [classes]="'w-full'"
                      type="text"
                      formControlName="groupAdministration"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'groupAdministration') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'level-position-before-' + $index"
                      [classes]="'w-full'"
                      type="number"
                      step="1"
                      min="0"
                      inputmode="numeric"
                      formControlName="levelPosition"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'levelPosition') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell classes="employee-action-cell">
                    <div class="employee-action-cell__content">
                      <app-buttons
                        type="button"
                        [label]="'Eliminar'"
                        [classes]="'bg-secondary-base text-secondary-light'"
                        [disabled]="before.length <= 1"
                        (click)="removeBeforeRow($index)" />
                    </div>
                  </desy-table-advanced-row-cell>
                </desy-table-advanced-row>
              }
            </desy-table-advanced>
          </div>

          <div
            class="flex flex-col gap-4"
            formArrayName="after">
            <div class="flex w-full items-center justify-between gap-4">
              <label
                class="text-[16px] font-semibold flex-1 max-w-[820px]"
                for="total-people-after-0">
                Empleados públicos de la unidad o servicio implicados en la tramitación del procedimiento o servicio
                tras el despliegue del proyecto IA*
              </label>
              <desy-button
                class="flex-shrink-0"
                [type]="'button'"
                classes="c-button c-button--primary ng-star-inserted"
                (clickEvent)="addAfterRow()">
                Añadir registro
              </desy-button>
            </div>
            <span class="text-[16px] text-neutral-dark">
              Cada registro debe tener cumplimentados los 3 campos obligatorios.
            </span>
            <desy-table-advanced
              classes="min-w-full employee-table"
              idPrefix="table-after-employees"
              [wrapper]="{ classes: 'overflow-x-auto' }">
              <desy-table-advanced-header>
                <desy-table-advanced-header-cell>
                  <desy-content>Total de empleados públicos tras el despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Grupo de administración tras el despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Nivel de puesto tras el despliegue*</desy-content>
                </desy-table-advanced-header-cell>
                <desy-table-advanced-header-cell>
                  <desy-content>Acción</desy-content>
                </desy-table-advanced-header-cell>
              </desy-table-advanced-header>
              @for (row of afterEmployeeRows; track $index) {
                <desy-table-advanced-row [formGroupName]="$index">
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'total-people-after-' + $index"
                      [classes]="'w-full'"
                      type="number"
                      step="0.01"
                      min="0"
                      inputmode="decimal"
                      formControlName="totalPeople"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'totalPeople') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'group-administration-after-' + $index"
                      [classes]="'w-full'"
                      type="text"
                      formControlName="groupAdministration"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'groupAdministration') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>
                    <desy-input
                      [id]="'level-position-after-' + $index"
                      [classes]="'w-full'"
                      type="number"
                      step="1"
                      min="0"
                      inputmode="numeric"
                      formControlName="levelPosition"></desy-input>
                    <desy-error-message *ngIf="getEmployeeRowError(row, 'levelPosition') as error">
                      {{ error }}
                    </desy-error-message>
                  </desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell classes="employee-action-cell">
                    <div class="employee-action-cell__content">
                      <app-buttons
                        type="button"
                        [label]="'Eliminar'"
                        [classes]="'bg-secondary-base text-secondary-light'"
                        [disabled]="after.length <= 1"
                        (click)="removeAfterRow($index)" />
                    </div>
                  </desy-table-advanced-row-cell>
                </desy-table-advanced-row>
              }
            </desy-table-advanced>
          </div>
        </div>

        <div class="flex flex-col">
          <div class="h-6"></div>
          <label class="text-[16px] font-semibold">Número de personas afectadas por el proceso*</label>
          <div class="flex gap-2">
            <div class="flex flex-col flex-1">
              <span class="text-[16px] text-neutral-dark">Ciudadanos*</span>
              <desy-input
                [classes]="'w-full'"
                type="text"
                inputmode="numeric"
                formControlName="amountAffectedCitizens"></desy-input>
              <desy-error-message
                *ngIf="
                  getError(
                    form,
                    'amountAffectedCitizens',
                    !!form.get('amountAffectedCitizens')?.dirty || formSubmitted()
                  ) as error
                ">
                {{ error }}
              </desy-error-message>
            </div>
            <div class="flex flex-col flex-1">
              <span class="text-[16px] text-neutral-dark">Funcionarios*</span>
              <desy-input
                [classes]="'w-full'"
                type="text"
                inputmode="numeric"
                formControlName="amountAffectedOfficials"></desy-input>
              <desy-error-message
                *ngIf="
                  getError(
                    form,
                    'amountAffectedOfficials',
                    !!form.get('amountAffectedOfficials')?.dirty || formSubmitted()
                  ) as error
                ">
                {{ error }}
              </desy-error-message>
            </div>
          </div>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación económica de implantación (€)</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="economicEstimateImplementation"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'economicEstimateImplementation',
                !!form.get('economicEstimateImplementation')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación económica de mantenimiento anual (€)</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="economicEstimateAnnualMaintenance"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'economicEstimateAnnualMaintenance',
                !!form.get('economicEstimateAnnualMaintenance')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación económica de consumo (€)</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="economicEstimateConsumption"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'economicEstimateConsumption',
                !!form.get('economicEstimateConsumption')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación del coste de aplicación actual (€)*</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="currentApplicationCostEstimate"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'currentApplicationCostEstimate',
                !!form.get('currentApplicationCostEstimate')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Otros costos derivados</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="otherDerivedCosts"></desy-input>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación del coste del personal actual*</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="currentStaffCostEstimate"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'currentStaffCostEstimate',
                !!form.get('currentStaffCostEstimate')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col relative">
          <label class="text-[16px]">Estimación del coste del personal tras el despliegue*</label>
          <desy-input
            [classes]="'w-full'"
            type="number"
            step="0.01"
            min="0"
            formControlName="postDeploymentStaffCostEstimate"></desy-input>
          <desy-error-message
            *ngIf="
              getError(
                form,
                'postDeploymentStaffCostEstimate',
                !!form.get('postDeploymentStaffCostEstimate')?.dirty || formSubmitted()
              ) as error
            ">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label class="text-[16px] font-semibold">Plazo medio de resolución*</label>
          <div class="flex gap-2">
            <div class="flex flex-col flex-1">
              <span class="text-[16px] text-neutral-dark">Meses estimados tras implantar IA*</span>
              <desy-input
                type="number"
                [classes]="'w-full'"
                formControlName="averageResolutionEstimateTime"></desy-input>
              <desy-error-message *ngIf="getError(form, 'averageResolutionEstimateTime', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
            <div class="flex flex-col flex-1">
              <span class="text-[16px] text-neutral-dark">Meses actualmente*</span>
              <desy-input
                type="number"
                [classes]="'w-full'"
                formControlName="averageResolutionRealTime"></desy-input>
              <desy-error-message *ngIf="getError(form, 'averageResolutionRealTime', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Datos de entrada -->
    <div class="flex flex-col gap-4 py-8">
      <span class="text-xl font-bold">Datos de entrada</span>
      <div class="flex gap-4">
        <div class="flex flex-col flex-1">
          <label class="text-[16px]">Datos personales tratados por el sistema de IA*</label>
          <desy-select
            formControlName="personalSelectedDataType"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona una opción
            </desy-option>
            <desy-option
              *ngFor="let item of typeDataPersonal"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'personalSelectedDataType', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div
          class="flex flex-col flex-1"
          *ngIf="form.get('personalSelectedDataType')?.value !== 1"></div>
        <div
          class="flex flex-col flex-1"
          *ngIf="form.get('personalSelectedDataType')?.value === 1">
          <label class="text-[16px]">Categoría de datos personales tratados*</label>

          <p-multiSelect
            [options]="categoryDataPersonal"
            [filter]="false"
            [showToggleAll]="false"
            formControlName="categoryDataPersonalSelected"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecciona categorías"
            class="mt-2"
            [panelStyleClass]="'custom-multiselect-panel'">
            <ng-template
              let-values
              pTemplate="selectedItems">
              {{ getSelectedCategoriesText(values) }}
            </ng-template>
          </p-multiSelect>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div *ngIf="form.get('categoryDataPersonalSelected')?.value.includes('5')">
          <div>
            <div class="text-md">Tratamiento de datos biométricos*</div>
            <div class="text-[16px] text-neutral-dark">
              Explicación de los datos biométricos y qué actividad de tratamiento tiene.
            </div>
          </div>
          <desy-textarea
            formControlName="biometricData"
            classes="w-full"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
        </div>
        <desy-error-message *ngIf="getError(form, 'biometricData', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>

        <div class="grid grid-cols-2 gap-4 mb-6">
          <div class="flex flex-col col-span-1">
            <label
              class="text-[16px] mb-2"
              for="project-name">
              Actividad de tratamiento publicada en el Registro de Actividades de Tratamiento del Gobierno de Aragón
              (RAT)*
            </label>
            <p-autoComplete
              [(ngModel)]="ratSearch"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onRatSearchChange($event)"
              [suggestions]="ratList"
              (completeMethod)="onSearchRat($event)"
              (onSelect)="onRatSelected($event)"
              (onBlur)="onRatBlur()"
              [forceSelection]="true"
              placeholder="Buscar el código RAT"
              optionLabel="label"
              [minLength]="1"
              [dropdown]="false"
              [inputStyle]="{ width: '100%' }">
              <ng-template
                let-item
                pTemplate="item">
                {{ item.id_rat }} - {{ item.nombre_rat }}
              </ng-template>
            </p-autoComplete>
            <desy-error-message
              *ngIf="getError(form, 'rat', formSubmitted()) as error"
              class="rat-error-message">
              {{ error }}
            </desy-error-message>
          </div>
          <div class="col-span-1"></div>
        </div>

        <div class="flex flex-col">
          <label class="text-[16px] font-bold">
            Evaluación de impacto en la protección de datos personales (EIPD)*
          </label>
          <desy-radios
            formControlName="isDataSensitive"
            name="rat-treatment"
            idPrefix="rat">
            <desy-radio-item value="no-realizada">
              <desy-label>No realizada</desy-label>
            </desy-radio-item>

            <desy-radio-item
              value="seleccionar-fecha"
              [conditional]="true">
              <desy-label>Fecha evaluación de impacto</desy-label>
              <desy-content>
                <div class="mt-2">
                  <label class="text-[16px] block">Fecha</label>
                  <label class="text-[16px] mb-2 block text-neutral-dark">
                    La fecha seleccionada debe ser anterior a hoy ({{ currentDateFormatted }})
                  </label>
                  <p-datepicker
                    formControlName="eipd"
                    dateFormat="dd-mm-yy"
                    [maxDate]="maxSelectableDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    inputStyleClass="mi-input"
                    placeholder="dd-mm-aaaa"
                    class="w-full"></p-datepicker>
                  <div class="mt-4">
                    <label class="text-[16px] block">CSV*</label>
                    <desy-input
                      id="csvEipd"
                      [classes]="'w-[48%]'"
                      [placeholder]="'Código identificador del documento'"
                      formControlName="csvEipd"></desy-input>
                  </div>
                </div>
              </desy-content>
            </desy-radio-item>
          </desy-radios>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-xl font-bold">Gestión del riesgo</span>
      <div class="flex gap-4">
        <div class="flex flex-col flex-1">
          <label class="text-[16px]">Clasificación del sistema*</label>
          <desy-select
            formControlName="projectClassification"
            classes="w-[50%] mt-2">
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona un valor
            </desy-option>
            <desy-option
              *ngFor="let item of riskLevelOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
        </div>
      </div>
    </div>
  </div>
</form>
<p-confirmdialog />
